import React,{useEffect} from "react";
import Nav from 'react-bootstrap/Nav';
import { Link } from "react-router-dom";
import PermissionCheck from "../Auth/PermissionCheck";
import { useLocation } from 'react-router-dom';
import { databaseRoleCode } from '../../settings';

export function SideBarItem({ user, name, base, permissions, path, icon, hidden, super_admin_show, menuActivePaths, className }) {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(document.body.classList.contains('sidebar-icons'));

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsSidebarCollapsed(document.body.classList.contains('sidebar-icons'));
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);

    const location = useLocation();
    const pathname = location.pathname;
    let isActive = false;
    if (pathname !== path && pathname !== '') {
        if (menuActivePaths) {
            let findArray = menuActivePaths.filter(function (menu) { return pathname.includes(menu); });
            if (findArray.length > 0) {
                isActive = true;

            }
        }
    }
    else {
        isActive = true;
    }

    if (super_admin_show) {
    } else {
        if (hidden)
            return <></>
    }

    const closeSideBarMenu = () => {
        // Only close sidebar on mobile screens (<992px)
        // On desktop screens, preserve the current sidebar state
        const isMobile = window.innerWidth <= 992;
        if (isMobile) {
            localStorage.setItem("drawerPosition", true);
        }
        // On desktop, do nothing - sidebar state remains unchanged
    }
    
    return <PermissionCheck permissions={permissions}>
        {user.role_code === databaseRoleCode.clientCode && name === "Site Add-on Tasks" ? '' :
            <>
                {name === "Manage Dev Plans" ?
                    <>
                        {user?.current_plan.includes('dev') ?
                            <Nav.Item as="li" className={className}>
                                <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                            </Nav.Item> : ''}
                    </>
                    :
                    name === "Bucket Tracking Report" && (user.role_code === databaseRoleCode.clientCode || user.role_code === databaseRoleCode.agencyCode || user.role_code === databaseRoleCode.agencyMemberCode) ?
                        <>
                            {user?.current_plan.includes("bucket") &&
                                <Nav.Item as="li" className={className}>
                                    <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                                </Nav.Item>
                            }
                        </>
                        :
                        name === "Time Tracking Report" && (user.role_code === databaseRoleCode.clientCode || user.role_code === databaseRoleCode.agencyCode || user.role_code !== databaseRoleCode.agencyMemberCode) ?
                            <>
                                {/* {user?.current_plan.includes("dev-personalized-addon") && */}
                                    <Nav.Item as="li" className={className}>
                                        <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                                    </Nav.Item>
                                {/* } */}
                            </>
                            :
                            name === "Agency Bucket Plans" ?
                                <>
                                    {user.role_code !== databaseRoleCode.agencyCode && user.role_code !== databaseRoleCode.clientCode && user.role_code !== databaseRoleCode.agencyMemberCode &&
                                        <Nav.Item as="li" className={className}>
                                            <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                                        </Nav.Item>
                                    }
                                </>
                                :
                                name === "WFH Request" ?
                                    (user.is_wfh === 0 || user.role_code === databaseRoleCode.adminCode || user.role_code === databaseRoleCode.teamLeadCode) ?
                                        <Nav.Item as="li" className={className}>
                                            <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                                        </Nav.Item> : ''
                                :
                                name === "Remaining Leave List" ?
                                    (user.role_code === databaseRoleCode.adminCode || user.role_code === databaseRoleCode.hrCode) ?
                                        <Nav.Item as="li" className={className}>
                                            <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                                        </Nav.Item> : ''
                                    :
                                    name === "Roles" ?
                                        (user.role_code === databaseRoleCode.adminCode || user.role_code === databaseRoleCode.hrCode) ?
                                            <Nav.Item as="li" className={className}>
                                                <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                                            </Nav.Item> : ''
                                        :
                                        (user.role_code === databaseRoleCode.clientCode && name === "Favourite Tasks") ?
                                            '' :
                                            <Nav.Item as="li" className={className}>
                                                <Link to={base + path} onClick={() => closeSideBarMenu()} className={`nav-link ${isActive ? 'active' : ''}`} title={isSidebarCollapsed? name : ''} ><i className={icon}></i><span>{user.role_code === databaseRoleCode.clientCode && name === "All Dev Tasks" ? 'Tasks' : name}</span></Link>
                                            </Nav.Item>

                }
            </>
        }
    </PermissionCheck>
}